import React from 'react'
import { Link } from 'react-router-dom'
import ModulesIcon from '../../node_modules/@mui/icons-material/ViewModule'
import Top100 from '../../node_modules/@mui/icons-material/Money'
import NetWorthIcon from '../../node_modules/@mui/icons-material/TrendingUp'
import PersonIcon from '../../node_modules/@mui/icons-material/Person'
import HelpVideoIcon from '../../node_modules/@mui/icons-material/Videocam'
import './FooterResults.css'

const FooterPractice = (props) => {

	const modulesIconColor = props.view === 'launchpad' ? '#33cc33' : '#f1faee'
	const top100IconColor = props.view === 'top100' ? '#33cc33' : '#f1faee'
	const networthIconColor = props.view === 'rewards' ? '#33cc33' : '#f1faee'
	const personIconColor = props.view === 'profile' ? '#33cc33' : '#f1faee'
	const extraVideoIconColor = props.view === 'videohelp' ? '#33cc33' : '#f1faee'
	
	return (
		<React.Fragment>
			<div className='footer'>
				<div className='footer-control-bar' >
					
						<Link 
							className='footer-bar-icon'
							to={{
								pathname: '/launchpad'
							}}
							state={{
								view: 'modules'
							}}
						>
						<ModulesIcon 
							style={{
								width: '100%',
								height: '100%',
								color: modulesIconColor
							}}
						/></Link>
					
					
						<Link 
							className='footer-bar-icon'
							to={{
								pathname: '/launchpad/top100'
							}}
							state={{
								view: 'top100',
								lpath: 1442
							}}
						>
						<Top100 
							style={{
								width: '100%', 
								height: '100%',
								color: top100IconColor
							}} 
						/>
						</Link>
					
					
						<Link 
							className='footer-bar-icon'
							to={{
								pathname: '/launchpad/rewards'
							}}
							state={{
								view: 'rewards'
							}}
						>
						<NetWorthIcon
							style={{
								width: '100%',
								height: '100%', 
								color: networthIconColor
							}}
						/>
						</Link>
					
					
						<Link 
							className='footer-bar-icon'
							to={{
								pathname: '/launchpad/profile'
							}}
							state={{
								view: 'profile',
								username: null,
								lpath: null,
								title: null,
								backlink: null
							}}
						>
						<PersonIcon 
							style={{
								width: '100%',
								height: '100%',
								color: personIconColor
							}}
						/></Link>
					
					
						<Link 
							className='footer-bar-icon'
							to={{
								pathname: '/launchpad/videohelp'
							}}
							state={{
								view: 'videohelp'
							}}
						>
						<HelpVideoIcon
							style={{ 
								width: '100%',
								height: '100%',
								color: extraVideoIconColor
							}}
						/></Link>
					
				</div>
			</div>
		</React.Fragment>
	)
}

export default FooterPractice

